import { reactive, readonly } from 'vue';

// App-wide toasts, stacked in the top-right corner by UiToaster (rendered
// once in the shell). Like shadcn's Sonner: each one closes by itself after
// a few seconds, and only the newest few stay on screen.
const MAX_VISIBLE = 3;
const DURATION = 4000;

const state = reactive({ toasts: [] });
let nextId = 0;

function dismiss(id) {
  const i = state.toasts.findIndex((t) => t.id === id);
  if (i !== -1) state.toasts.splice(i, 1);
}

function show(type, message, title = '', duration = DURATION) {
  const id = ++nextId;
  state.toasts.unshift({ id, type, title, message, duration });
  state.toasts.splice(MAX_VISIBLE);
  return id;
}

export function useToast() {
  return {
    state: readonly(state),
    success: (message, title) => show('success', message, title),
    error: (message, title) => show('error', message, title),
    info: (message, title) => show('info', message, title),
    warning: (message, title) => show('warning', message, title),
    // For callers that pick the type at run time or need their own duration.
    show,
    // One toast by id, or all of them.
    dismiss: (id) => (id == null ? state.toasts.splice(0) : dismiss(id)),
  };
}
